import Swiper, { Navigation, Pagination } from 'swiper';

export function initVehiclesSwiper() {
    const containers = document.querySelectorAll('.js-vehiclesSwiper');
    if (containers.length === 0) return;

    containers.forEach(container => {
        const allChildren = Array.from(container.children);
        if (allChildren.length === 0) return;

        const slides = allChildren.slice(0, 8);
        allChildren.slice(8).forEach(el => el.remove());

        const swiperWrapper = document.createElement('div');
        swiperWrapper.classList.add('swiper-wrapper');

        slides.forEach(slide => {
            slide.classList.add('swiper-slide');
            swiperWrapper.appendChild(slide);
        });

        container.appendChild(swiperWrapper);

        const wrapper = container.parentElement;

        const prevButton = document.createElement('div');
        prevButton.classList.add('swiper-button-prev', 'swiper-button-itemlist-prev');
        prevButton.innerHTML = '<i class="icon icon-angle-left"></i>';
        wrapper.appendChild(prevButton);

        const nextButton = document.createElement('div');
        nextButton.classList.add('swiper-button-next', 'swiper-button-itemlist-next');
        nextButton.innerHTML = '<i class="icon icon-angle-right"></i>';
        wrapper.appendChild(nextButton);

        const pagination = document.createElement('div');
        pagination.classList.add('swiper-pagination', 'swiper-pagination-clickable', 'swiper-pagination-bullets', 'swiper-pagination-horizontal');
        container.appendChild(pagination);

        new Swiper(container, {
            modules: [Navigation, Pagination],
            slidesPerView: 4,
            spaceBetween: 0,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            breakpoints: {
                0: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
            },
        });
    });
}